import useMutationApi from 'src/api/useMutationApi';

const endpoint = 'organization/groups';

interface NewGroupDTO {
  name: string;
  description: string;
}

interface Body {
  groups: NewGroupDTO[];
}

interface CreatedGroupDTO {
  id: string;
  name: string;
  description: string;
}

interface ApiResponse {
  groups: CreatedGroupDTO[];
}

export type { CreatedGroupDTO, ApiResponse as CreateGroupsResponse };

interface UseCreateGroupsOptions {
  onSuccess?: (res: ApiResponse) => void;
  showSuccessToast?: boolean;
}

function useCreateGroups(options?: UseCreateGroupsOptions) {
  return useMutationApi<Body, ApiResponse>({
    endpoint: endpoint,
    method: 'POST',
    showSuccessToast: options?.showSuccessToast ?? true,
    options: {
      onSuccess: options?.onSuccess
        ? (res) => {
            options.onSuccess?.(res.data);
          }
        : undefined,
    },
  });
}

export default useCreateGroups;
